import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Heading from '@components/Heading'
import Divider from '@components/Divider'
import Text from '@components/Text'
import Button from '@components/Button'
import {
    COLORS,
    DIVIDER_SIZE,
    BUTTON_TYPE,
    HEADING_TYPE,
    TEXT_SIZES,
} from '@helpers/constants'

const ValidateQuizAnswers = (props) => {
    const { score, questions, restartQuiz, reviewQuestions, closePanel } = props

    const successThreshold = 100
    const percent = Math.floor((score * 100) / questions.length)

    return (
        <div className={'flex flex-col items-center'}>
            <Divider size={DIVIDER_SIZE.BASE} />
            <Heading headingLevel={HEADING_TYPE.H2} size={TEXT_SIZES.XLARGE}>
                Du fick {score} rätt av {questions.length}
            </Heading>

            <Divider size={DIVIDER_SIZE.SMALL} />

            {/* Actions depending on score */}
            {percent < successThreshold ? (
                <Button
                    type={BUTTON_TYPE.PRIMARY}
                    handleClick={() => {
                        reviewQuestions()
                    }}
                >
                    Se svar och gör om quiz
                </Button>
            ) : (
                <>
                    <Text>Bra jobbat, alla rätt!</Text>
                    <Divider size={DIVIDER_SIZE.SMALL} />

                    {percent === 100 ? (
                        <div className={'flex'}>
                            {/* All correct, 100% */}
                            <Button
                                type={BUTTON_TYPE.SECONDARY}
                                handleClick={() => {
                                    restartQuiz()
                                }}
                                margin
                            >
                                Gör om
                            </Button>
                            <Button
                                type={BUTTON_TYPE.PRIMARY}
                                handleClick={closePanel}
                                margin
                            >
                                Okej
                            </Button>
                        </div>
                    ) : (
                        // Over 80%, but not all correct
                        <Button
                            type={BUTTON_TYPE.PRIMARY}
                            handleClick={() => {
                                reviewQuestions()
                            }}
                        >
                            Se svar
                        </Button>
                    )}

                    <Divider size={DIVIDER_SIZE.SMALL} />
                </>
            )}
        </div>
    )
}

ValidateQuizAnswers.propTypes = {
    score: PropTypes.number,
    questions: PropTypes.array,
    restartQuiz: PropTypes.func,
    reviewQuestions: PropTypes.func,
    closePanel: PropTypes.func,
}

export default ValidateQuizAnswers
